import React, { useState, useEffect } from "react";
import { Container } from "../../globalStyles";
import DashboardPackageGroupSelection from "../../components/PackagesSection/DashboardPackageGroupSelection";
import CounterStats from "../../components/Stats/Counter/CounterStats";
import PieCharts from "../../components/Stats/PieCharts";
import TimeFrameSelector from "../../components/Stats/TimeFrameSelector";
import DataLoader from "../../components/Loader/DataLoader/DataLoader";
import { StatsPage, CenterLoader } from "../../components/Stats/StatsGroup.elements";
import {
  StatsTopBar,
  StatsTitleLeft,
  TimeSelectorWrap,
  StatsSection,
  StatsDivider,
} from "../../components/Stats/Counter/CountersBlock.elements";
import { useContributorsState, useStatsActions, useStatsState } from "@/store";

const StatGroup = () => {
  const { stats, status } = useStatsState();
  const { fetchStats } = useStatsActions();
  const { selectedContributorId } = useContributorsState();

  const [timeframe, setTimeframe] = useState("all");
  const [[fromDate, toDate], setDates] = useState([null, null]);

  useEffect(() => {
    fetchStats({
      contributors: selectedContributorId,
      fromDate,
      toDate,
    });
  }, [selectedContributorId, fromDate, toDate, fetchStats]);

  const handleSelectTimeFrame = ({ fromDate, toDate, value }) => {
    setTimeframe(value);
    setDates([fromDate, toDate]);
  };

  return (
      <StatsPage>
        <Container>
          <StatsSection>
            <StatsTopBar>
              <StatsTitleLeft>Quantity</StatsTitleLeft>

              <TimeSelectorWrap>
                <TimeFrameSelector
                    value={timeframe}
                    onSelectTimeFrame={handleSelectTimeFrame}
                    disabled={status === "loading"}
                />
              </TimeSelectorWrap>
            </StatsTopBar>

            {status === "loading" ? (
                <CenterLoader>
                  <DataLoader />
                </CenterLoader>
            ) : (
                <>
                  <CounterStats
                      uploads={stats.uploads || 0}
                      clips={stats.clips || 0}
                      avgRating={stats.avgRating || 0}
                  />

                  <PieCharts stats={stats} />

                  <StatsDivider />

                  <StatsTitleLeft>Recent uploads</StatsTitleLeft>

                  <DashboardPackageGroupSelection contributor={selectedContributorId} />
                </>
            )}
          </StatsSection>
        </Container>
      </StatsPage>
  );
};

export default StatGroup;